<template>
    <div 
        v-if="isOpen" 
        class="relative z-[1000000] after:content-[''] after:bg-[#0006] after:fixed after:inset-0 after:pointer-events-auto after:visible"
    >
        <dialog class="modal modal-open">
            <div class="modal-box p-0 max-w-lg lg:max-w-4xl overflow-visible">
                <button
                    type="button"
                    class="btn btn-sm btn-circle absolute top-[-16px] right-[-16px] z-10 btn-accent"
                    @click="closeModal"
                >
                    <MiscIcon name="x" />
                    <span class="sr-only">{{ $t('page.popup.close') }}</span>
                </button>
                
                <div class="rounded-box p-0 w-full max-w-none overflow-y-scroll md:overflow-visible no-scrollbar bg-base-200">
                    <div class="relative p-6 max-h-[calc(100vh-6rem)] z-1 w-full">
                        <div class="text-center pt-8">
                            <div class="text-3xl mb-5 whitespace-pre-line">
                                <template v-if="isAlreadyRegistered">
                                    {{ $t('page.popup.newsletterConfirmation.alreadyRegisteredHeadline') }}
                                </template>
                                <template v-else>
                                    {{ $t('page.popup.newsletterConfirmation.successHeadline') }}
                                </template>
                            </div>
                            
                            <div v-if="isAlreadyRegistered" class="text-xs mb-4">
                                {{ $t('page.popup.newsletterConfirmation.alreadyRegisteredDescription') }}
                            </div>
                        </div>

                        <div class="pt-4 text-center flex flex-col gap-2">
                            <button
                                type="button"
                                class="btn btn-primary"
                                @click="closeModal"
                            >
                                <template v-if="isAlreadyRegistered">
                                    {{ $t('page.popup.newsletterConfirmation.alreadyRegisteredButton') }}
                                </template>
                                <template v-else>
                                    {{ $t('page.popup.newsletterConfirmation.successButton') }}
                                </template>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </dialog>
    </div>
</template>

<script setup lang="ts">
const route = useRoute()
const router = useRouter()

const isOpen = ref(false)
const isAlreadyRegistered = ref(false)

onMounted(() => {
    const newsletterStatus = route.query.newsletter

    if (newsletterStatus === 'success') {
        isOpen.value = true
        isAlreadyRegistered.value = false
        router.replace({ query: { ...route.query, newsletter: undefined } })
    } else if (newsletterStatus === 'already-registered') {
        isOpen.value = true
        isAlreadyRegistered.value = true
        router.replace({ query: { ...route.query, newsletter: undefined } })
    }
})

function closeModal() {
    isOpen.value = false
    isAlreadyRegistered.value = false
}
</script>